<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="prosafety2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/home/PIP-logo.svg" alt="pip pro safety logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    PIP Pro-Safety is taking the PPE market by force with our extensive line of safety products that are favorable enough for the DIYer and strong enough for the PRO. 
                    The safety market is constantly evolving and as a company with more than forty years of experience in this market, it is our duty at PIP® to utilize our expertise to develop products that keep pace with the newest safety technologies and industry standards.  
                </p>
                <a href="javascript:void(0)" class="btn-round-black">Coming in 2025</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: #333;">
            <div>
                <div>
                    <h4>Follow Us</h4>
                    <div>
                        <a href="https://www.facebook.com/protectiveindustrialproducts" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-facebook']"  />
                        </a>
                        <a href="https://twitter.com/PIP_Global/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-x-twitter']" />
                        </a>
                        <a href="https://www.instagram.com/pip_global/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-instagram']" />
                        </a>
                        <a href="https://www.youtube.com/user/PIPUSAinc" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-youtube']" />
                        </a>
                        <a href="https://www.linkedin.com/company/protective-industrial-products" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'linkedin']" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:pr@westchestergear.com">
                                <font-awesome-icon :icon="['fas', 'envelope']" />
                            </a>                 
                            <a href="mailto:pr@westchestergear.com">pr@westchestergear.com</a>
                        </div>
                        <div>
                            <a href="tel:518-861-0133">
                                <font-awesome-icon :icon="['fas', 'phone']" />
                            </a>
                            <a href="tel:518-861-0133">(518) 861-0133</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Coming Soon</h4>
                    <div>
                        <a href="javascript:void(0)">
                            <img id="amazon-logo-faded" src="/images/amazon-logo-white.svg" alt="amazon logo">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
